var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  x: 0.5,
  y: 0.5,
  fill: "#26A6A6",
  rx: 11.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  x: 0.5,
  y: 0.5,
  stroke: "#26A6A6",
  rx: 11.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M6 12.667 9.333 16M9.334 16 18 7.333"
})));
export default SvgCheckCircleIcon;